import type { Theme } from 'paymentiq-cashier-bootstrapper';

export const piqTheme: Theme = {
  cashierbackground: {
    color: 'var(--background-body)'
  },
  buttons: {
    color: '#F62828'
  },
  headings: {
    color: '#0A0A0A'
  },
  labels: {
    color: 'var(--components-input-fg-primary, #0A0A0A)'
  },
  border: {
    radius: '999px'
  },
  loader: {
    color: '#F62828'
  },
  input: {
    color: 'var(--components-input-fg-primary, #0A0A0A)',
    fontSize: '14px',
    height: '56px',
    borderRadius: '999px'
  },
  inputbackground: {
    color: 'transparent'
  }
};

/*
export interface Theme {
  input?: {
    color?: string,
    fontSize?: string,
    height?: string,
    borderRadius?: string
  },
  inputbackground?: {
    color?: string
  },
  labels?: {
    color?: string,
    fontSize?: string
  },
  headings?: {
    color?: string,
    fontSize?: string
  },
  loader?: {
    color?: string,
  },
  error?: {
    color?: string
  },
  success?: {
    color?: string
  },
  buttons?: {
    color?: string,
  },
  headerbackground?: {
    color?: string,
  },
  background?: {
    color?: string,
  },
  cashierbackground?: {
    color?: string,
  },
  border?: {
    radius?: string,
  },
  margin?: {
    size?: string,
  },
  providerlogos?: {
    list?: string,
    dropdown?: string
  },
  creditcardicons?: {
    creditcardUrl?: string,
    cvvUrl?: string,
    expirydateUrl?: string
  }
}*/
